import { useDispatch, useSelector } from "react-redux"
import { useContext, useCallback } from "react"
import { viewContext } from "../context/viewContext"
import { updateLastRead as updateLastReadAction } from "../features/messages/updateLastRead"

export const useUpdateLastRead = () => {
  const { unique_owner_id } = useContext(viewContext)
  const dispatch = useDispatch()
  const owner = useSelector(state => state.owners[unique_owner_id])

  const status = owner?.actionStatuses?.updateLastRead?.status
  const loaded = owner?.actionStatuses?.updateLastRead?.loaded

  const isFetching = status === 'fetching'
  const isLoading = status === 'fetching' && !loaded
  const isSuccess = status === 'success'
  const error = status === 'failed'

  const updateLastRead = useCallback(async (params) => {
    try {
      const response = await dispatch(updateLastReadAction(params))
      return response
    } catch (error) {
      throw error
    }
  }, [dispatch])

  return [
    updateLastRead,
    {
      isFetching,
      isLoading,
      isSuccess,
      error,
    }
  ]
}
